import { render } from "./Credit.vue?vue&type=template&id=997d723a&scoped=true"
import script from "./Credit.vue?vue&type=script&lang=js"
export * from "./Credit.vue?vue&type=script&lang=js"

import "./Credit.vue?vue&type=style&index=0&id=997d723a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-997d723a"]])

export default __exports__